import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";
import { ConfigService } from "src/app/servicios/config/config.service";
import { PlatformService } from "src/app/servicios/platform/platform.service";
import { TitleWrapperService } from "src/app/servicios/title-wrapper/title-wrapper.service";
import { BloqueDestacadosComponent } from "../bloques-filas/bloque-destacados/bloque-destacados.component";
import { CommonMenuBurguerComponent } from "../common-menu-burguer/common-menu-burguer.component";
import { HeaderMovilComponent } from "../header-movil/header-movil.component";
import { HomeNavMenuComponent } from "../home-nav-menu/home-nav-menu.component";
import { LogoMenuComponent } from "../logo-menu/logo-menu.component";
import { SecondaryMenuComponent } from "../secondary-menu/secondary-menu.component";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
  imports: [BloqueDestacadosComponent, CommonModule, CommonMenuBurguerComponent, HeaderMovilComponent, HomeNavMenuComponent, LogoMenuComponent, SecondaryMenuComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  resizable: boolean; // Indica si el header puede cambiar de tamaño según la ruta.
  configPrensa: any; // Almacena la configuración de la aplicación obtenida del servicio ConfigService.
  showBloqueDestacados: boolean = false;

  /**
   * Constructor del componente.
   * @param titleWrapperService Servicio para establecer el título de la página.
   * @param configService Servicio para obtener configuraciones de la aplicación.
   * @param router Módulo de enrutamiento para detectar cambios de ruta.
   * @param platformService Servicio para información de la plataforma (browser, pathname, etc.).
   */
  constructor(
    private readonly titleWrapperService: TitleWrapperService,
    private readonly configService: ConfigService,
    private readonly router: Router,
    public platformService: PlatformService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  /**
   * ngOnInit:
   * - Define si el header es "resizable" dependiendo de la ruta actual y de la configuración.
   * - Escucha la configuración para ajustar el comportamiento del header.
   */
  ngOnInit(): void {
    this.resizable = this.router.url !== "/";

    this.configService.getConfigPrensa().subscribe((resultConfig) => {
      if (!resultConfig) return;
      this.configPrensa = resultConfig;
      this.showBloqueDestacados = resultConfig.general["app-bloque-destacados"].bloque_activo === "true";
      const isResizable = resultConfig.general["app-common-menu-burguer"].resizable === "true";
      this.configResizable(isResizable);
    });
  }

  /**
   * setDocTitle:
   * - Actualiza el título del documento a través de TitleWrapperService.
   * @param title Título a establecer.
   */
  setDocTitle(title: string): void {
    this.titleWrapperService.setTitle(title);
  }

  /**
   * configResizable:
   * - Activa o desactiva la capacidad del header de cambiar de tamaño.
   * - Suscribe al router para cambiar el estado "resizable" al navegar.
   * @param isResizable Indica si el header debe ser redimensionable.
   */
  configResizable(isResizable: boolean): void {
    if (!isResizable) {
      this.resizable = false;
      this.cdr.detectChanges();
      return;
    }

    this.resizable = this.platformService.getLocationPathname() !== "/";
    this.cdr.detectChanges();

    this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe((ev: NavigationEnd) => {
      this.resizable = ev.url !== "/";
      this.cdr.detectChanges();
    });
  }
}
